import { render, staticRenderFns } from "./VideoPlayerMulticam.vue?vue&type=template&id=0b9875f2&scoped=true&"
import script from "./VideoPlayerMulticam.vue?vue&type=script&lang=js&"
export * from "./VideoPlayerMulticam.vue?vue&type=script&lang=js&"
import style0 from "./VideoPlayerMulticam.vue?vue&type=style&index=0&id=0b9875f2&prod&lang=scss&"
import style1 from "./VideoPlayerMulticam.vue?vue&type=style&index=1&id=0b9875f2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b9875f2",
  null
  
)

export default component.exports